import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { css } from "styled-components";

quantityOrderedStyles.quantityOrdered = {
    cssOverrides: {
        formField: css`
            width: 100%;
            min-width: 5rem;
            margin: 0;
            label {
                display: none;
            }
        `,
        inputSelect: css`
            border: 1px solid #636262;
            text-align: center;
            font-weight: 700;
            min-height: 50px;
        `,
    },
};
